import React, { Component, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Router, Switch, Route, useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import {
  getLicensingData,
  getListOfAccts,
  pushNotification,
  getProfileRoleInfo,
  getListOfOrgsAndAccts,
  getListAccRules,
  getListAllRules,
} from '../../store/actions';
import AccountsConfig from './_accountsConfig';
import UsersConfig from './_usersConfig';
import SecurityConfig from './_securityConfig';
import ResourceGroupsConfig from "./_resourceGroupsConfig";
import Suppression from './Suppression';
import InaccessibleResources from '../../helpers/InaccessibleResources';
import OfflineCur from "../OfflineCur";

const freeLicenseName = process.env.REACT_APP_FREE_ORGANIZATION_LICENSE;
const freeLicenses = [freeLicenseName];

const Configuration = ({ licenseName }) => {

    console.log("Configuration page, licenseName: " , licenseName);
  const defaultRoutes = [
    {
      displayName: "Cloud Accounts",
      component: AccountsConfig,
      navLink: "/configuration/accounts",
    },
    {
      displayName: "Users",
      component: UsersConfig,
      navLink: "/configuration/users",
    },
    // {
    //   displayName: "Security",
    //   component: freeLicenses.includes(licenseName)? InaccessibleResources : SecurityConfig,
    //   navLink: "/configuration/security",
    // },
    {
      displayName: "Resource Groups",
      component: freeLicenses.includes(licenseName)? InaccessibleResources : ResourceGroupsConfig,
      navLink: "/configuration/resourcegroups",
    },
    {
      displayName: "Compliance Configuration",
      component: freeLicenses.includes(licenseName)? InaccessibleResources : Suppression,
      navLink: "/configuration/suppression",
    },
    {
      displayName: "Offline CUR",
      component: OfflineCur,
      navLink: "/configuration/offline-cur",
    },
  ];
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [mask, setMask] = useState(false);
  const [configRoutes, setConfigRoutes] = useState();
  const [contactForAsistance, setContactForAsistance] = useState(false);
  const [isCustomer, setIsCustomer] = useState(false);
  const licensing = useSelector((state) => state.licensing);
  const notifications = useSelector((state) => state.notify);
  const acctList = useSelector((state) => state.acctList);
  const orgAccount = useSelector((state) => state.orgAccount);
  const { data, costLookup, status } = licensing;

    useEffect(() => {
        // Check if customer is true in selectedOrganization
        const selectedOrganizationStr = localStorage.getItem('selectedOrganization');
        if (selectedOrganizationStr) {
            try {
                const selectedOrganization = JSON.parse(selectedOrganizationStr);
                setIsCustomer(selectedOrganization.customer === true);
            } catch (error) {
                console.error('Error parsing selectedOrganization:', error);
            }
        }

        if (!licensing?.data && !licensing?.loading && !licensing?.error) {
            dispatch(getLicensingData());
        }
        if (!acctList?.accounts && !acctList?.loading) {
            dispatch(getListOfAccts());
        }

        // console.log("Calling getProfileRoleInfo() from configuration.index#useEffect");
        // dispatch(getProfileRoleInfo());
        if ((!orgAccount?.accounts || !orgAccount?.organizations?.length) && !orgAccount?.loading) {
            dispatch(getListOfOrgsAndAccts());
        }
    }, []);
    useEffect(() => {
        if (licensing && licensing.data && licensing.data.numAccounts && acctList && acctList.accounts) {
            const numAccounts = licensing.data.numAccounts;
            const accountNotification = {message: `${acctList.accounts.length -1}/${numAccounts}`, 
            fullmessage:`Accounts ${acctList.accounts.length -1} of ${numAccounts} Used`,
            amend: false};
            if (acctList.accounts.length-1 < numAccounts) {
                accountNotification.className="badge badge-outline bg-white border border-secondary"
            } else if (acctList.accounts.length >= numAccounts) {
                accountNotification.className="badge-mine"
            }
            dispatch(pushNotification(accountNotification));

            const numUsers = licensing.data.numUsers;
            const temp = [];
            acctList.accounts.forEach((item) => {
                item.listusr.forEach((entity) => temp.push(entity))
            });
            const usersNotification = {message: `${acctList.usersConfig.length}/${numUsers}`, 
            fullmessage:`Users ${acctList.usersConfig.length} of ${numUsers} Used`,
            amend: true};
            if (acctList.usersConfig.length < numUsers) {
                usersNotification.className="badge badge-outline bg-white border border-secondary"
            } else if (acctList.usersConfig.length >= numUsers) {
                usersNotification.className = "badge-mine"
            }
            dispatch(pushNotification(usersNotification));
        }
    }, [licensing, acctList])

    useEffect(() => {
        const updatedRoutes = [];
        defaultRoutes.forEach((item) => {
            // Check if current path matches the route or is a sub-route
            const isActive = location.pathname === item.navLink || 
                           (item.navLink !== "/configuration/accounts" && 
                            location.pathname.startsWith(item.navLink));
            updatedRoutes.push({
                displayName: item.displayName,
                navLink: item.navLink,
                isActive: isActive
            })
        });
        setConfigRoutes(updatedRoutes);
    }, [location])

    useEffect(() => {
        
        if (data && !data.isLicensingComplete && data.licenseName === "NONE") {
            console.log("data is here ", data)
            setMask(true)
            setContactForAsistance(true)
        } else {
            setMask(false);
        }
    }, [data])

    const handleRedirectLink = (e) => {
        const isDirty = sessionStorage.getItem('isDirty', 'true');
        const targetLink = e.target.getAttribute('link');
        console.log('--== targetLink ', targetLink);
        if (targetLink && !isDirty) {
            e.preventDefault();
            e.stopPropagation();
            history.push(targetLink)
        }
    }

    // If customer is true, show only UsersConfig without tabs
    if (isCustomer) {
        return (
            <React.Fragment>
                <div className="page-content" style={{backgroundColor: '#fff'}}>
                    <Container fluid>
                        <Card className={mask ? "mask" : ""}>
                            <CardBody>
                                <UsersConfig />
                                <Modal isOpen={contactForAsistance}>
                                    <ModalBody>
                                        <div className="form-check">
                                            <label className="form-check-label" htmlFor="agreeTerms">
                                                Licensing must be completed before any changes can be made.
                                            </label>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <button type="button" className="btn btn-secondary" onClick={() => setContactForAsistance(false)}>OK</button>
                                    </ModalFooter>
                                </Modal>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{backgroundColor: '#fff'}}>
                <Container fluid>
                    <Card className={mask ? "mask" : ""}>
                        <CardBody>
                            <Row>
                                <Col xs={8}>
                                    {
                                        configRoutes && (
                                            <ul className="nav nav-pills" style={{
                                                display: 'inline-flex',
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: '8px',
                                                padding: '4px',
                                                gap: '4px',
                                                margin: 0
                                            }}>
                                                {
                                                    configRoutes.map((item, index) => {
                                                        return (
                                                            <li key={index} className="nav-item" style={{ margin: 0 }}>
                                                                <button
                                                                    onClick={handleRedirectLink}
                                                                    link={item.navLink}
                                                                    className={`btn btn-sm nav-link ${item.isActive ? 'active' : ''}`}
                                                                    style={{
                                                                        borderRadius: '6px',
                                                                        margin: 0,
                                                                        fontWeight: '500'
                                                                    }}
                                                                >
                                                                    {item.displayName}
                                                                </button>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <hr />
                                    <div className="mt-1"></div>
                                    <Switch>
                                        {
                                            defaultRoutes && defaultRoutes.map((item) => {
                                                return (
                                                    <Route path={item.navLink} component={item.component} />
                                                )
                                            })
                                        }
                                    </Switch>
                                </Col>
                            </Row>
                            <Modal isOpen={contactForAsistance}>
                                <ModalBody>
                                    <div className="form-check">
                                        <label className="form-check-label" htmlFor="agreeTerms">
                                            Licensing must be completed before any changes can be made.
                                        </label>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <button type="button" className="btn btn-secondary" onClick={() => setContactForAsistance(false)}>OK</button>
                                </ModalFooter>
                            </Modal>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}


export default Configuration;